import styled from "styled-components";

export const LineBorder = styled.div`
  width: 95%;
  margin-left: 2.5%;
  height: 2px;
  border-radius: 2px;
  background: var(--content-color);
`;
